import React, { Component } from "react";
import PropTypes from "prop-types";
import "./VMButton.scss";
import ToolTip from "../MakeVideo/Common/MakeVideoTooltip";

class VMButton extends Component {
  getBtnStyleObject = () => {
    const { isFlexBtn, style } = this.props
    if (isFlexBtn) {
      return {
        ...style,
        minWidth: this.props.width,
        height: this.props.height,
        display: "table",
        textAlign: "center",
        padding: "0 5px",
      }
    }

    return {
      ...style,
      width: this.props.width,
      height: this.props.height,
      display: "table",
      textAlign: "center",
    }
  }
  render() {
    if (this.props.isTooltip) {
      return (
        <ToolTip
          placement={this.props.toolTipPlacement}
          content={this.props.toolTipContent}
        >
          <div
            className={"button " + this.props.color}
            style={this.getBtnStyleObject()}
            onClick={this.props.onClick}
          >
            <div style={{ display: "table-cell", verticalAlign: "middle" }}>
              {this.props.children}
            </div>
          </div>
        </ToolTip>
      );
    }
    return (
      <div
        className={"button " + this.props.color}
        style={this.getBtnStyleObject()}
        onClick={this.props.onClick}
      >
        <div lang={this.props.value} style={{ display: "table-cell", verticalAlign: "middle" }}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

VMButton.defaultProps = {
  color: "default",
  width: "100px",
  height: "80px",
  isFlexBtn: false
};

VMButton.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "default", "disabled", "dark-gray-v2", "primary-v2", "default-v2"]),
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  isFlexBtn: PropTypes.bool
};

export default VMButton;
